import { useCallback, useEffect, useState } from "react";
import { API_URL } from "../_services/apiUrl";
import { toast } from "react-toastify";
import { get, post } from "../_services/apiService";
import Layout from "./Shared/Layout";

const imageurl = process.env.REACT_APP_IMAGE_BASE_URL

const MyProfile = () => {
    const loginId = localStorage.getItem("loginId");
    const [loginDetailById, setLoginDetailById] = useState([]);

    const GetLoginDetailById = useCallback(async () => {
        try {
            const response = await get(`${API_URL?.GetLoginDetailById}?pLoginDetailId=${loginId}`);
            if (response.isSuccess === 200) {
                setLoginDetailById(response.data[0]);
            }
        } catch (error) {
            toast.error(error.message);
        }
    }, [loginId]);

    useEffect(() => {
        GetLoginDetailById();
    }, [GetLoginDetailById])

    const handleIconClick = () => {
        document.getElementById("profile-image-input").click();
    };

    const handleFileChange = async (e) => {
        const file = e.target.files[0];
        if (file) {

            try {
                const formData = new FormData();
                formData.append("file", file);
                formData.append("LoginId", loginId);

                const response = await post(API_URL?.SaveUserImage, formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                });

                if (response.isSuccess === 200) {
                    toast.success("Profile image uploaded successfully!");
                    GetLoginDetailById();
                }
            } catch (error) {
                toast.error("Error uploading image: " + error.message);
            }
        }
    };

    return (
        <Layout>
            <section className="faqs_main layout_main">
                <div className="container-screen container d-flex justify-content-center">
                    <div className="col-12">
                        <div className="page-header">
                            <h1>My Profile</h1>
                        </div>
                        <div className="row justify-content-center mt-4">
                            <div className="profile-container col-lg-4 col-md-6 col-sm-8 col-11">
                                <div className="profile_icon_image" onClick={handleIconClick}>
                                    <i className="fa fa-pencil"></i>
                                    <img
                                        src={loginDetailById?.impgPath ? `${imageurl}${loginDetailById?.impgPath}` : './images/gray-user-profile-icon.png'}
                                        alt="UserProfilePicture"
                                        className="profile-image"
                                    />
                                    <input
                                        type="file"
                                        id="profile-image-input"
                                        style={{ display: "none" }}
                                        onChange={handleFileChange}
                                        accept="image/*"
                                    />
                                </div>
                                <div className="profile-content">
                                    <div className="profile-name"> {loginDetailById?.name}</div>
                                    <div className="profile-info">
                                        <span>Mobile :</span> {loginDetailById?.mobileNo}
                                    </div>
                                    <div className="profile-info">
                                        <span>Email :</span> {loginDetailById?.emailId}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </Layout>
    )
}

export default MyProfile;